import dynamic from "next/dynamic";

export default dynamic(() => import("./Avatar"), { ssr: false });
